import React, { useState } from "react";
import { Table, Grid, Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import familyGroupColumns from "../columns/familyGroupColumns";
import FamilyChildrenTable from "./FamilyChildrenTable";
import FamilyGroupModal from "../modals/FamilyGroupModal";
import FamilyReportOptionsModal from "../modals/FamilyReportOptionsModal";

const { useBreakpoint } = Grid;

export default function FamilyGroupTable({ data }) {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [reportFamily, setReportFamily] = useState(null);

  const screens = useBreakpoint();
  const isMobile = !screens.md; // ✅ md < 768px = mobile

  const handleOpenModal = (record) => {
    setSelectedRecord(record);
    setModalOpen(true);
  };

  // ✅ Mobile-specific columns (only 3 fields)
  // ✅ Mobile-specific columns (3 fields + XIRR + Absolute)
  const mobileColumns = [
    {
      title: "Group Name",
      dataIndex: "group_name",
      key: "group_name",
      render: (text, record) => (
        <a onClick={() => handleOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "PAN",
      dataIndex: "master_pan",
      key: "master_pan",
      render: (text, record) => (
        <a onClick={() => handleOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "Current Value",
      dataIndex: ["totals", "current_value"],
      key: "current_value",
      render: (val) => `₹${Number(val || 0).toLocaleString()}`,
    },
    {
      title: "XIRR (%)",
      dataIndex: ["totals", "xirr"],
      key: "xirr",
      align: "right",
      render: (val) => {
        if (val === null || val === undefined) return "-";
        const color = val > 0 ? "green" : "red";
        return <span style={{ color }}>{Number(val).toFixed(2)}</span>;
      },
    },
    {
      title: "Abs.Ret(%)",
      dataIndex: ["totals", "absolute"],
      key: "absolute",
      align: "right",
      render: (val) => {
        if (val === null || val === undefined) return "-";
        const color = val > 0 ? "green" : "red";
        return <span style={{ color }}>{Number(val).toFixed(2)}</span>;
      },
    },    {
      title: "PDF",
      key: "pdf",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Button type="text" title="Build Family Portfolio Report"
          icon={<FilePdfOutlined style={{ fontSize: 21, color: "#d32f2f" }} />}
          onClick={(e) => { e.stopPropagation(); setReportFamily(record); }} />
      ),
    },
  ];

  return (
    <>
      <Table
  		className="family-table"
        rowKey="master_pan"
        columns={isMobile ? mobileColumns : familyGroupColumns(handleOpenModal, setReportFamily)}
        dataSource={data}
        expandable={{
          expandedRowRender: (record) => (
            <FamilyChildrenTable masterPan={record.master_pan} />
          ),
          expandedRowKeys: expandedKeys,
          onExpand: (expanded, record) => {
            setExpandedKeys((prev) =>
              expanded
                ? [...prev, record.master_pan]
                : prev.filter((k) => k !== record.master_pan)
            );
          },
        }}
        bordered
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }} // ✅ prevent cutoff on small screens
      />

      <FamilyGroupModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        record={selectedRecord}
      />

      <FamilyReportOptionsModal
        open={!!reportFamily}
        family={reportFamily}
        onClose={() => setReportFamily(null)}
      />
    </>
  );
}
